import Image from '@atoms/Image/Image';
import { IPromoCartItem } from '@models/IPromoCartItem';
import classNames from 'classnames';

interface Props extends IPromoCartItem {
  readonly titleClassName?: string;
  readonly rewardClassName?: string;
}

const PromoCartItem = ({
  promoReward,
  promoTitle,
  thumbnailImage,
  titleClassName = 'body-one',
  rewardClassName = 'body-one body-one--bold',
}: Props) => (
  <div
    className="flex items-center gap-x-6 rounded-[10px] border border-grey bg-white p-4"
    data-testid="Promo-Cart-Item"
  >
    <div className="h-[84px] w-[84px] shrink-0">
      <Image
        image={thumbnailImage}
        imageClasses="object-cover w-full h-full rounded-[10px]"
        data-testid="Promo-Cart-Item-Image"
      />
    </div>

    <div className="flex grow justify-between gap-2 max-xl:flex-col xl:items-center">
      <p className={titleClassName} data-testid="Promo-Cart-Item-Title">
        {promoTitle}
      </p>

      <p
        className={classNames(rewardClassName, 'whitespace-nowrap')}
        data-testid="Promo-Cart-Item-Reward"
      >
        {promoReward}
      </p>
    </div>
  </div>
);

export default PromoCartItem;
